// @mui
import PropTypes from 'prop-types';
import { alpha, styled } from '@mui/material/styles';
import { Card, Palette, PaletteColor, Typography } from '@mui/material';
// utils
//import { fShortenNumber } from '../../../utils/formatNumber';
// components
//import Iconify from '../../../components/iconify';


import { GrFormPreviousLink, GrFormNextLink } from 'react-icons/gr';

import numeral from 'numeral';

import { useRecoilValue } from 'recoil';

import {  currentUserSessionAtom } from 'library/store';


import  {iconFromName} from '../../components/ui/DynamicIcon';
import { isFalsy } from 'utility-types';

// ----------------------------------------------------------------------

const StyledIcon = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
}));

// ----------------------------------------------------------------------


export interface WidgetSummaryProps {    
    title: string,
    total: number,
    total2?: number,
    decimalScale?: 0|1|2|3|4;
    iconName: string,    
    paletteColor: PaletteColor,
    
}

export default function WidgetSummaryBasic(prop: WidgetSummaryProps) {

  
  const {title, total, total2, decimalScale, paletteColor, iconName } = prop;

  const {language: lg} = useRecoilValue(currentUserSessionAtom);

  var formatter = new Intl.NumberFormat(lg.includes('en')?'en-US': 'fr-FR', { 
                minimumFractionDigits: decimalScale??0 , maximumFractionDigits: decimalScale??0 });

  const sTotal = formatter.format(total);

  return (
    <Card
      sx={{
        py: 1,
        boxShadow: 0,
        textAlign: 'center',
        color: paletteColor.dark , // (theme) => theme.palette['primary'].dark, //.palette[color].darker,
        bgcolor: paletteColor.light,
        //width: '100%'
        flex: 1
        //...sx,
      }}
      //{...other}
    >      

      <Typography variant="h5" sx={{ opacity: 0.99, fontWeight: 'bold' }}>{`${sTotal}`}</Typography>

      <Typography variant="subtitle2" sx={{ opacity: 0.99, fontWeight: 'bold' }}>
        {title}
      </Typography>
    </Card>
  );
}